import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../../../config";
import "./EstimatingTurnaround.css";

// "Estimating Turnaround" widget — a table (styled like Tiered Customer
// Performance) comparing estimates Requested (CubiCasa orders by order date) vs
// Completed (Nancy unit types whose first room was traced), with % Complete, for
// WK / QTD / YTD. Aggregate totals only. The backend anchors all periods to the
// current week's Monday, so it updates each Monday and stays static until the next.
const PERIODS = [
  { key: "week", label: "WK" },
  { key: "qtd", label: "QTD" },
  { key: "ytd", label: "YTD" },
];

const EstimatingTurnaround = ({ auth: { auth } }) => {
  const [data, setData] = useState(null);

  const token = auth && auth[0] ? auth[0].token : null;

  useEffect(() => {
    if (!token) return;
    // Guard against setting state after the widget unmounts (the dashboard can
    // re-render/unmount widgets while this request is still in flight).
    let active = true;
    axios
      .get(`${API_URL}/Dashboard/api/Dashboard/EstimatingTurnaround`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (!active) return;
        const rows = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.result) || [];
        setData(rows[0] || null);
      })
      .catch((err) => {
        if (!active) return;
        console.warn("Could not load Estimating Turnaround:", err.message);
      });
    return () => {
      active = false;
    };
  }, [token]);

  const period = (key) =>
    (data && data[key]) ? data[key] : { requested: 0, completed: 0, pctComplete: 0 };

  return (
    <div className="et-widget">
      <h4 className="et-title" style={{'textAlign':'center'}}>Estimating Turnaround</h4>
      <table className="et-table">
        <thead>
          <tr>
            <th></th>
            {PERIODS.map((p) => (
              <th key={p.key}>{p.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="et-label">Requested Estimates</td>
            {PERIODS.map((p) => (
              <td key={p.key} className="et-num">{period(p.key).requested}</td>
            ))}
          </tr>
          <tr>
            <td className="et-label">Completed Estimates</td>
            {PERIODS.map((p) => (
              <td key={p.key} className="et-num">{period(p.key).completed}</td>
            ))}
          </tr>
          <tr>
            <td className="et-label">% Complete</td>
            {PERIODS.map((p) => (
              <td key={p.key} className="et-num">{period(p.key).pctComplete}%</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(EstimatingTurnaround);
